import React from 'react';
import {TextInputProps} from 'react-native';
import {useTheme} from 'styled-components/native';

import {
  Container,
  ContainerButton,
  Input,
  InputButton,
  InputText,
  SearchIcon,
} from './styles';

import theme from '../../../../../global/styles/legacy/theme';

interface ISearchInput extends TextInputProps {
  shadow?: boolean;
  forceLightAppearence?: boolean;
  isButtonInput?: {
    text: string;
    action: () => void;
  };
}

export function SearchInput({
  shadow,
  forceLightAppearence,
  isButtonInput,
  ...rest
}: ISearchInput) {
  const theme_ = useTheme();

  return !shadow ? (
    !isButtonInput ? (
      <Container
        style={{
          backgroundColor: forceLightAppearence
            ? theme_.colors.input_search
            : theme_.colors.input_search,
        }}>
        <Input {...rest} placeholderTextColor={theme_.colors.text} />

        <SearchIcon
          name="search"
          style={{
            color: theme_.colors.text,
          }}
        />
      </Container>
    ) : (
      <ContainerButton
        activeOpacity={1}
        onPress={isButtonInput.action}
        style={{
          backgroundColor: forceLightAppearence
            ? theme_.colors.input_search
            : theme_.colors.input_search,
        }}>
        <InputButton>
          <InputText numberOfLines={1} ellipsizeMode="tail">
            {isButtonInput.text}
          </InputText>
        </InputButton>

        <SearchIcon
          name="search"
          style={{
            color: theme_.colors.text,
            paddingRight: 24,
            paddingLeft: 12,
          }}
        />
      </ContainerButton>
    )
  ) : !isButtonInput ? (
    <Container
      style={{
        backgroundColor: forceLightAppearence
          ? theme.colors.input_search
          : theme_.colors.input_search,
        shadowColor: theme_.colors.text_dark,
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.1,
        shadowRadius: 6,
        elevation: 8,
      }}>
      <Input {...rest} placeholderTextColor={theme_.colors.text} />

      <SearchIcon
        name="search"
        style={{
          color: theme_.colors.text,
        }}
      />
    </Container>
  ) : (
    <ContainerButton
      activeOpacity={1}
      onPress={isButtonInput.action}
      style={{
        backgroundColor: forceLightAppearence
          ? theme.colors.input_search
          : theme_.colors.input_search,
        shadowColor: theme_.colors.text_dark,
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.1,
        shadowRadius: 6,
        elevation: 8,
      }}>
      <InputButton>
        <InputText>{isButtonInput.text}</InputText>
      </InputButton>

      <SearchIcon
        name="search"
        style={{
          color: theme_.colors.text,
          paddingRight: 24,
          paddingLeft: 12,
        }}
      />
    </ContainerButton>
  );
}
